import { Flex, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

export interface BaseControlProps{
    requiredField?: boolean;
    fieldTitle?: string;
    children?: ReactNode;
    isEmpty?: boolean
    errorText?: string;
    containerStyles?: React.CSSProperties;
}

export const BaseControl = ({ requiredField=false, fieldTitle, children, isEmpty=false, errorText, containerStyles = {}, }: BaseControlProps) => {
    return (
        <Flex 
            flexDirection="column" 
            gap={2}
            style={containerStyles}
        >
            {fieldTitle && (
                <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color="gray.700"
                    display="flex"
                    alignItems="center"
                    gap={1}
                >
                    {fieldTitle}
                    {requiredField && (
                        <Text as="span" color="red.500">*</Text>
                    )}
                </Text>
            )}
            {children}
            {errorText && (
                <Text fontSize="xs" color="red.500" mt={1}>
                    {errorText}
                </Text>
            )}
            {requiredField && isEmpty && (
                <Text fontSize="xs" color="red.500" mt={1}>
                    Обязательное поле
                </Text>
            )}
        </Flex>
    );
};
